import { createContext as t } from "use-context-selector";
const e = t({});
export {
  e as default
};
//# sourceMappingURL=context.js.map
